<template>
	<div class="app" :style="{backgroundImage: `url('${background}')`}">
		<component :is="layout" :key="layout">
			<router-view/>
		</component>

		<notifications classes="notify" position="top right"/>
	</div>
</template>

<script>
import l_base from "@/components/layouts/base.vue";
import l_main from "@/components/layouts/main.vue";

export default {
	components: {l_base, l_main},
	data() {
		return {
			background: require("@/assets/images/background.png")
		}
	},
	computed: {
		routeLayout: (t) => t.$route.meta.layout || "base",
		layout: (t) => `l_${t.routeLayout}`
	}
};
</script>
<style lang="scss" scoped>
.app {
	background-color: #F4F6F8;
	min-height: 100vh;

	/deep/ {
		.notification {
			&.notify {
				box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.08);
				font-size: 0.9em;
				padding: 1em;
				margin: 1em;
				margin-bottom: 0em;
				background-color: #636464;
				border-left: 6px solid $black1;
				color: $white1;
			}

			&-title {
				margin-bottom: 0.5em;
			}
			&-content {
				font-size: 14px;
			}
		}
	}
}
</style>
